import { Home, BookOpen, UtensilsCrossed, ShieldCheck } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { content, APP_OGGI, APP_DIARIO, APP_CATALOG, APP_ANALYSIS } from "@/content/fitswag";
import Reveal from "@/components/Reveal";

function Card({ testid, icon: Icon, title, desc, img, alt, span, delay }) {
  return (
    <Reveal delay={delay} className={span}>
      <div
        data-testid={testid}
        className="group relative flex h-full flex-col overflow-hidden rounded-3xl border border-white/10 bg-white/[0.03] p-7 transition-transform duration-300 hover:-translate-y-1"
      >
        <div className="flex items-center gap-3">
          <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-brand-orange/15 text-brand-orange">
            <Icon size={20} />
          </span>
          <h3 className="font-display text-2xl tracking-tight text-white">{title}</h3>
        </div>
        <p className="mt-3 max-w-md leading-relaxed text-white/60">{desc}</p>
        {img && (
          <div className="mt-6 overflow-hidden rounded-2xl border border-white/10">
            <img
              src={img}
              alt={alt}
              loading="lazy"
              className="w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.03]"
              style={{ maxHeight: 280 }}
            />
          </div>
        )}
      </div>
    </Reveal>
  );
}

export default function BentoFeatures() {
  const { lang } = useLanguage();
  const t = content[lang].bento;

  return (
    <section id="features" className="relative border-t border-white/10 bg-black py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <Reveal className="max-w-2xl">
          <p className="overline text-brand-orange">{t.overline}</p>
          <h2 className="mt-3 font-display text-4xl leading-tight tracking-tighter text-white sm:text-5xl md:text-6xl">
            {t.title}
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-5 md:grid-cols-6">
          <Card
            testid="bento-home"
            icon={Home}
            title={t.home.title}
            desc={t.home.desc}
            img={APP_OGGI}
            alt="FitSwag Home"
            span="md:col-span-4"
            delay={0}
          />
          <Card
            testid="bento-score"
            icon={ShieldCheck}
            title={t.score.title}
            desc={t.score.desc}
            img={APP_ANALYSIS}
            alt="Punteggio FitSwag"
            span="md:col-span-2"
            delay={0.08}
          />
          <Card
            testid="bento-diary"
            icon={BookOpen}
            title={t.diary.title}
            desc={t.diary.desc}
            img={APP_DIARIO}
            alt="Diario FitSwag"
            span="md:col-span-3"
            delay={0.12}
          />
          <Card
            testid="bento-catalog"
            icon={UtensilsCrossed}
            title={t.catalog.title}
            desc={t.catalog.desc}
            img={APP_CATALOG}
            alt="Catalogo FitSwag"
            span="md:col-span-3"
            delay={0.16}
          />
        </div>
      </div>
    </section>
  );
}
